module.exports = __webpack_public_path__ + "img/detail-btn.02a1d95f.png";